<template>

  <div>

    <ProductionOrderLabelPrintHistoryDialog
        :history-item="historyItem"/>

    <t-table
        @getPage="getPageHistory()"
        :show="checkViewListTableDefault()"
        :filtered="filtered"
        :busy="!pageListIsLoaded"
        :user-auth="userAuth"
        :items="request.content"
        :fields="fields"
        :total-pages="request.totalPages"
        :total-elements="request.totalElements"
        title-items="impressões"
        link-primary-column="label"
        class="p-2"
        primary-key-column="productionOrderLabelPrintHistoryId">

      <template #actions="{item}">

        <t-button
            text="Detalhes"
            @click="openHistoryDetail(item)"
            icon-list/>

      </template>

    </t-table>

  </div>

</template>


<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service"
import ProductionOrderLabelPrintHistoryDialog from "@/views/modules/general/ProductionOrderLabelPrintHistoryDialog.vue";


export default {

  mixins: [
    pageDefaultMixin,
    pageFormMixin,
    pageListMixin
  ],

  components: {
    ProductionOrderLabelPrintHistoryDialog
  },

  name: 'ProductionOrderLabelPrintHistory',

  props: {

    productionOrderId: {
      type: Number,
      required: true
    }

  },

  data() {

    return {

      filtered: false,

      pageHistoryNumber: 1,

      searchParamsHistory: new URLSearchParams(),

      path: "production/order-label-print-history",

      fields: [
        {
          key: "label",
          label: "Etiqueta",
          cols: "3",
        },
        {
          key: "createdDate",
          label: "Data da Impressão",
          cols: "2",
          formatter: "datetime"
        },
        {
          key: "createdUser",
          label: "Responsável",
          cols: "3"
        },
        {
          key: "printNumber",
          label: "Via",
          cols: "2"
        },
        {
          key: "quantity",
          label: "Qtd.",
          cols: "2",
          align: "right"
        }
      ],

      //--------------------------------------------------------------------------------------
      historyItem: {}
      //--------------------------------------------------------------------------------------

    }

  },

  methods: {

    mountedPrepare() {

      this.searchParamsHistory.set(
          "productionOrderId",
          this.productionOrderId
      )

    },

    async mountedContinued() {

      await this.getPageHistory(1)

      this.pageListIsLoaded = true

    },

    //--------------------------------------------------------------------------------------
    // Início de métodos personalizados desta tela

    async getPageHistory(pageNumber, finishLoaded = true) {

      this.pageListIsLoaded = false

      await crudGeneral
          .getAll(
              this.path,
              pageNumber,
              this.searchParamsHistory
          )
          .then(response => {

            this.request = response.data

            if (finishLoaded)
              this.pageListIsLoaded = true

          })
          .catch(error => {
            this.responseError(error)
          })

    },

    openHistoryDetail(item) {

      this.historyItem = item

      this.openDialogForm(
          'modal-production-order-label-print-history-detail'
      )

    }

    //--------------------------------------------------------------------------------------

  },

  async mounted() {

    this.mountedPrepare()

    await this.getPageHistory(
        this.pageHistoryNumber,
        false
    )

    await this.mountedContinued()

  }

}

</script>